"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KinesisVideo = exports.HighVolume = exports.PostTimestream = exports.Classic = void 0;
exports.Classic = {
    name: 'Classic',
    date: '2024 February',
    url: 'https://docs.google.com/document/d/1esQMZ-K_4jjiA79HagIhAa8h4zNM3f776t-dlwxyYHY',
};
exports.PostTimestream = {
    name: 'Post-Timestream',
    date: '2025 December',
    url: 'https://docs.google.com/document/d/1ir8Zq4_scA-YOIjU-KdS6_emhCJNyiko0YrF8Xk9XLk',
};
exports.HighVolume = {
    name: 'High-Volume',
    date: '2026 January',
    url: 'https://docs.google.com/document/d/1NnwWwcTq4HszhEEP23QT0W9PF8QurPyA5KsIw7mHL5M',
};
exports.KinesisVideo = {
    name: 'Kinesis-Video',
    date: '2026 March',
    url: '',
};
